<template>
  <!-- Kommentar-Popup (#48): active comment on top + scrollable history + add. -->
  <span class="ocp" @click.stop>
    <button
        class="ocp-trigger"
        :class="{ 'has-comment': hasComment }"
        :title="order.active_comment || 'Kommentar hinzufügen'"
        @click="toggle"
    >
      <i class="fas fa-comment-dots"></i>
    </button>

    <div v-if="open" class="ocp-panel" @click.stop>
      <div class="ocp-active" v-if="order.active_comment">
        <span class="ocp-label">Aktueller Kommentar</span>
        <p>{{ order.active_comment }}</p>
      </div>

      <div class="ocp-history" v-if="comments.length">
        <span class="ocp-label">Verlauf</span>
        <ul>
          <li v-for="c in comments" :key="c.id">
            <span class="ocp-meta">{{ c.user_name }} · {{ formatDate(c.created_at) }}</span>
            <span class="ocp-text">{{ c.text }}</span>
          </li>
        </ul>
      </div>
      <div v-else-if="!loading" class="ocp-empty">Noch keine Kommentare.</div>

      <div class="ocp-add">
        <textarea v-model="draft" rows="2" placeholder="Kommentar eingeben …"></textarea>
        <div class="ocp-actions">
          <button class="ocp-cancel" @click="open = false">Schließen</button>
          <button class="ocp-save" :disabled="!draft.trim() || saving" @click="save">Speichern</button>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import api from '@/api'

export default {
  name: 'OrderCommentPopup',
  props: { order: { type: Object, required: true } },
  data() { return { open: false, comments: [], draft: '', loading: false, saving: false } },
  computed: {
    hasComment() { return !!this.order.active_comment }
  },
  methods: {
    toggle() {
      this.open = !this.open
      if (this.open) this.load()
    },
    async load() {
      this.loading = true
      try {
        const res = await api.get(`orders/${this.order.id}/comments`)
        this.comments = res.data || []
      } catch (e) {
        this.comments = []
      } finally {
        this.loading = false
      }
    },
    async save() {
      this.saving = true
      try {
        const res = await api.post(`orders/${this.order.id}/comments`, { text: this.draft.trim() })
        this.comments.unshift(res.data)
        // newest = active comment; let the parent reflect it without a reload
        this.$emit('updated', res.data.text)
        this.draft = ''
      } catch (e) {
        // surfaced via toast elsewhere; keep the draft so nothing is lost
      } finally {
        this.saving = false
      }
    },
    formatDate(v) {
      if (!v) return ''
      try { return new Date(v).toLocaleString('de-DE') } catch { return v }
    }
  }
}
</script>

<style scoped>
.ocp { position: relative; display: inline-block; }
.ocp-trigger {
  border: none; background: transparent; cursor: pointer; color: #9ca3af;
  padding: 2px 4px; font-size: .9rem;
}
.ocp-trigger.has-comment { color: #2563eb; }
.ocp-panel {
  /* Anchor to the trigger's right edge so it opens inward and never pushes
     past the viewport (the trigger usually sits on the right of a header/row). */
  position: absolute; z-index: 50; top: 120%; right: 0; left: auto; width: 280px;
  max-width: calc(100vw - 24px);
  background: #fff; border: 1px solid #d1d5db; border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,.15); padding: 10px; text-align: left;
}
.ocp-label { font-size: .7rem; text-transform: uppercase; color: #6b7280; letter-spacing: .03em; }
.ocp-active p { margin: 2px 0 8px; font-size: .85rem; }
.ocp-history { max-height: 160px; overflow-y: auto; margin-bottom: 8px; }
.ocp-history ul { list-style: none; margin: 4px 0 0; padding: 0; }
.ocp-history li { border-top: 1px solid #f3f4f6; padding: 4px 0; }
.ocp-meta { display: block; font-size: .7rem; color: #9ca3af; }
.ocp-text { font-size: .85rem; }
.ocp-empty { font-size: .8rem; color: #9ca3af; margin-bottom: 8px; }
.ocp-add textarea { width: 100%; box-sizing: border-box; font: inherit; font-size: .85rem; padding: 4px 6px; }
.ocp-actions { display: flex; justify-content: flex-end; gap: 6px; margin-top: 6px; }
.ocp-actions button { cursor: pointer; border-radius: 5px; padding: 3px 10px; border: 1px solid #d1d5db; background: #fff; }
.ocp-cancel { background: #fef2f2; color: #b91c1c; border-color: #fecaca; }
.ocp-cancel:hover { background: #fee2e2; }
.ocp-save { background: #16a34a; color: #fff; border-color: #16a34a; }
.ocp-save:hover:not(:disabled) { background: #15803d; }
.ocp-save:disabled { opacity: .5; cursor: default; }
</style>
